import png from './images/knights.png'

export const colors = {
  dominant: '#0D499C',
  highlight: '#fcb53e',
}
export const fullname = 'Knights'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/knights.js